import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import UserBio from '../components/UserBio';
export default function extendUserCard() {
  extend(UserCard.prototype, 'infoItems', function (items) {
    // @TODO: fix typing here after `UserCard` is typed properly
    // @ts-ignore
    const user = this.attrs.user;
    // @ts-ignore
    const canEdit = this.attrs.editable;
    if (!user.attribute('canViewBio')) {
      return;
    }
    items.add('bio', m(UserBio, {
      user: user,
      editable: canEdit
    }), -100);
  });
}
flarum.reg.add('fof-user-bio', 'forum/extenders/extendUserCard', extendUserCard);